import Service from './Service'
import { API_BASE_URL } from '@/config/environment'

class LocalStorageService extends Service {

  fetch (data) {
    return this.globalState.js.$http
      .get(`${API_BASE_URL}/staticData`, { params: data })
  }

}

LocalStorageService.id = 'LocalStorageService'

export default LocalStorageService


